module.exports = __webpack_public_path__ + "img/1560325518.3dd78949.jpg";